<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

import ContextMenu from '../common/ContextMenu.vue'

export default {
    name: 'AnalyzesComponent',

    components: {
        ContextMenu
    },

    props: {
        analyzes: {
            type: Array,
            requiered: true
        },
        selectedItem: {
            type: Number,
            default: -1
        },
        role: {
            type: Number,
            default: 0
        }
    },

    emits: ['selected-analyze','show-attachments'],

    data() {
        return {
            showContextMenu: false
        }
    },

    methods: {
        setSelectedAnalyze(value) {
            this.$emit('selected-analyze', value)
        },
        showAttachments(value) {
            this.$emit('selected-analyze', value)
            this.$emit('show-attachments', value)
        },

        rightClick(e) {
            this.showContextMenu = true
            this.$refs.contextMenu.open(e);         
        },
        copyToClipboard() {
            if (this.analyzes.length > 0) {
                let text = ''

                for (let j = 1; j < this.analyzes[0].length; j++) {
                    for (let i = 0; i < this.analyzes.length; i++) {
                        if (i > 0) {
                            text += '\t'
                        }
                        if (this.analyzes[i][j].id != -1) {
                            if (i !== 0 && j === 1) {
                                if (this.analyzes[i][j].analysisConclusion != null && this.analyzes[i][j].analysisConclusion) {
                                    text += 'R'
                                }
                                else {
                                    text += 'G'
                                }
                                if (this.analyzes[i][j].attachments != null && this.analyzes[i][j].attachments) {
                                    text += ' A'
                                }
                                if (this.role > 1 && this.role < 5 &&  this.analyzes[i][j].locked) {
                                    text += ' L'
                                }
                            }
                            else {
                                text += this.analyzes[i][j].value
                            }
                        }
                        else {
                            text += this.analyzes[i][j].value
                        }                        
                    }
                    text += '\n'
                }

                navigator.clipboard.writeText(text)
            }

            this.showContextMenu = false
        },
        createSample() {
            if (this.selectedItem > 0) {
                let a = this.analyzes.find(arr => arr.some(o => o.id === this.selectedItem))
                if (a != null) {
                    window.location = window.location + '?sample=' + a[2].value
                }
            }
        }
    }
}
</script>


<template>
    <div v-if="analyzes.length > 0" @click.right.prevent="rightClick">
        <div v-for="(row, i) in analyzes" :key="i">
            <div v-for="(cell, j) in row" :key="j">
                <template v-if="cell.id != -1">
                    <span v-if="i === 0" class="analyze-column first-column">{{ cell.value.replaceAll(' ', '&nbsp;') }}</span>
                    
                    <span v-else-if="i !== 0 && j === 0" class="analyze-column">{{ cell.value.replaceAll(' ', '&nbsp;') }}</span>
                    
                    <span v-else-if="i !== 0 && j === 1" @click="setSelectedAnalyze(cell.id)" class="analyze-column first-row">
                        <!-- <img v-if="row.some((c) => c.semaphore === 'red')" src="@/assets/images/circle-red.svg" height="15px" />
                        <img v-else-if="row.some((c) => c.semaphore === 'orange')" src="@/assets/images/circle-orange.svg" height="15px" />
                        <img v-else src="@/assets/images/circle-green.svg" height="15px" /> -->
                        <img v-if="cell.analysisConclusion != null && cell.analysisConclusion == 3" src="@/assets/images/circle-red.svg" height="15px" />
                        <img v-else-if="cell.analysisConclusion != null && cell.analysisConclusion == 2" src="@/assets/images/circle-orange.svg" height="15px" />
                        <img v-else-if="cell.analysisConclusion != null && cell.analysisConclusion == 1" src="@/assets/images/circle-yellow.svg" height="15px" />
                        <img v-else-if="cell.analysisConclusion != null && cell.analysisConclusion == 0" src="@/assets/images/circle-green.svg" height="15px" />
                        <img v-else src="@/assets/images/circle-grey.svg" height="15px" />

                        <span v-if="cell.attachments != null && cell.attachments">
                            <span>&nbsp;</span>
                            <img src="@/assets/images/paperclip.svg" height="15px" style="cursor: pointer;" @click.stop="showAttachments(cell.id)" />
                        </span>

                        <span v-if="role > 1 && role < 5 && cell.locked">
                            <span>&nbsp;</span>
                            <img src="@/assets/images/lock.svg" height="15px" />
                        </span>
                    </span>
                    
                    <span v-else @click="setSelectedAnalyze(cell.id)" :class="'analyze-column selectable ' + (j === 2 && cell.id === selectedItem ? 'selected ' : '') + (cell.semaphore != null ? cell.semaphore : '')" :title="cell.title != null && cell.title.length > 0 ? cell.title : ''">
                        {{ cell.value.length > 0 ? cell.value.replaceAll(' ', '&nbsp;') : '&nbsp;' }}
                    </span>
                </template>

                <template v-if="cell.id == -1">
                    <span class="analyze-column" :title="cell.title != null && cell.title.length > 0 ? cell.title : ''">{{ cell.value != null && cell.value.length > 0 ? cell.value : '&nbsp;' }}</span>
                </template>
            </div>
        </div>
    </div>

    <ContextMenu :display="showContextMenu" ref="contextMenu">
        <div @click.prevent="copyToClipboard">Kopírovat do schránky</div>
        <div v-if="analyzes.length > 1 && analyzes[0].length == 10 && this.selectedItem != -1 && analyzes[0][9].value == 'Stroj'" @click.prevent="createSample">Založit vzorek</div>
    </ContextMenu>
</template>